import { render } from "./EmptyView.vue?vue&type=template&id=54ff91fa&scoped=true"
import script from "./EmptyView.vue?vue&type=script&lang=js"
export * from "./EmptyView.vue?vue&type=script&lang=js"

import "./EmptyView.vue?vue&type=style&index=0&id=54ff91fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ff91fa"]])

export default __exports__